"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioEditDisplay = exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.reflect.get");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

var _lodash = _interopRequireDefault(require("lodash"));

var _Radio = _interopRequireDefault(require("../radio/Radio"));

var _ExpertiseComponent2 = _interopRequireDefault(require("./ExpertiseComponent"));

var _BaseExpertiseForm = _interopRequireDefault(require("./BaseExpertiseForm"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Radio =
/*#__PURE__*/
function (_ExpertiseComponent) {
  _inherits(Radio, _ExpertiseComponent);

  function Radio(component, options, data) {
    var _this;

    _classCallCheck(this, Radio);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Radio).call(this, component, options, data));

    if (_this.component.validate && _this.component.validate.required) {
      _this.validators = _this.validators.concat(['expertiseRadioRequired']);
    }

    _this.valueScoreListMap = {};
    _this.isFirstOpen = true;
    return _this;
  }

  _createClass(Radio, [{
    key: "setScoreValues",
    value: function setScoreValues(isNotFirstOpen) {
      if (isNotFirstOpen) {
        this.isFirstOpen = false;
      }

      this.setValueScoreMap();
      this.setMinScore();
      this.setMaxScore();
      var score = this.getScore();
      this.setScoreToData(score);
    }
  }, {
    key: "setValueScoreMap",
    value: function setValueScoreMap() {
      var _this2 = this;

      this.valueScoreMap = this.component.values.reduce(function (obj, val) {
        var score = _this2.getScoreFormat(val.score);

        var setScoreListInObj = function setScoreListInObj(scoreList) {
          _this2.valueScoreListMap[val.value] = scoreList;
          obj[val.value] = Number(_this2.getCurrentScoreFormList(scoreList));
        };

        if (_typeof(score) !== 'object') {
          obj[val.value] = Number(score);
        } else {
          if (_this2.isFirstOpen && !_this2.component.hideScore) {
            _this2.checkListOrder(val.value, score).then(function (scoreList) {
              setScoreListInObj(scoreList);

              if (_this2.selectElement) {
                _this2.clearOptions();

                _this2.setScoreOptions(true);
              }
            });
          } else {
            setScoreListInObj(score);
          }
        }

        return obj;
      }, {});
    }
  }, {
    key: "checkListOrder",
    value: function checkListOrder(inputValue, score) {
      var _this3 = this;

      return this.dataReady.then(function () {
        var currentScore = _this3.data["score-".concat(_this3.component.key)];

        if (currentScore && _this3.data[_this3.component.key] === inputValue && _this3.isFirstOpen) {
          _this3.isFirstOpen = false;
          return score.sort(function (value) {
            if (Number(value) === currentScore) {
              return -1;
            }

            return 0;
          });
        }

        return score;
      });
    }
  }, {
    key: "setMinScore",
    value: function setMinScore() {
      var _this4 = this;

      this.minScore = this.component.values.reduce(function (min, val) {
        var score = _this4.getScoreFormat(val.score);

        score = _typeof(score) !== 'object' ? Number(score) : _this4.getCurrentScoreFormList(score);
        return score < min ? score : min;
      }, Number.MAX_VALUE);
    }
  }, {
    key: "setMaxScore",
    value: function setMaxScore() {
      var _this5 = this;

      this.maxScore = this.component.values.reduce(function (max, val) {
        var score = _this5.getScoreFormat(val.score);

        score = _typeof(score) !== 'object' ? Number(score) : _this5.getCurrentScoreFormList(score);
        return score > max ? score : max;
      }, 0);
    }
  }, {
    key: "getScore",
    value: function getScore() {
      if (!this.valueScoreMap) {
        this.setScoreValues();
      }

      var score;
      var radioValue = this.dataValue ? this.dataValue.radioValue : '';

      if (!this.selectElement) {
        score = radioValue ? this.valueScoreMap[radioValue] : 0;
      } else {
        var selectValue = this.selectElement.value || '';
        score = radioValue && selectValue ? this.valueScoreMap[radioValue] : 0;
      }

      return score;
    }
  }, {
    key: "getScoreFormat",
    value: function getScoreFormat(score) {
      if (score) {
        if (score.toString().includes(';')) {
          return score.split(';');
        }

        return score;
      }

      return 0;
    }
  }, {
    key: "getCurrentScoreFormList",
    value: function getCurrentScoreFormList(score) {
      if (this.container) {
        var select = this.container.querySelector('select');

        if (select) {
          return Number(select.value);
        }
      }

      return Number(score[0]);
    }
  }, {
    key: "getMinScore",
    value: function getMinScore() {
      return this.minScore;
    }
  }, {
    key: "getMaxScore",
    value: function getMaxScore() {
      return this.maxScore;
    }
  }, {
    key: "createInput",
    value: function createInput(container) {
      var _this6 = this;

      var inputGroup = this.ce('div', {
        class: 'form-group'
      });
      var labelOnTheTopOrOnTheLeft = this.optionsLabelOnTheTopOrLeft();
      var wrappers = [];

      _lodash.default.each(this.component.values, function (value) {
        var wrapperClass = "form-check ".concat(_this6.optionWrapperClass);

        var labelWrapper = _this6.ce('div', {
          class: wrapperClass
        });

        var label = _this6.ce('label', {
          class: 'control-label form-check-label'
        });

        _this6.addShortcut(label, value.shortcut); // Determine the attributes for this input.


        var inputId = _this6.id;

        if (_this6.options.row) {
          inputId += "-".concat(_this6.options.row);
        }

        inputId += "-".concat(_this6.root.id, "-").concat(value.value);
        _this6.info.attr.id = inputId;
        _this6.info.attr.value = value.value;
        label.setAttribute('for', _this6.info.attr.id); // Create the input.

        var input = _this6.ce('input');

        _lodash.default.each(_this6.info.attr, function (attrValue, key) {
          if (key === 'name' && _this6.component.inputType === 'radio') {
            attrValue += "[".concat(_this6.root.id, "]");
          }

          input.setAttribute(key, attrValue);
        });

        var labelSpan = _this6.ce('span');

        if (value.label && labelOnTheTopOrOnTheLeft) {
          label.appendChild(labelSpan);
        }

        _this6.setInputLabelStyle(label);

        _this6.setInputStyle(input);

        _this6.addInput(input, label);

        if (value.label) {
          labelSpan.appendChild(_this6.text(_this6.addShortcutToLabel(value.label, value.shortcut)));
        }

        if (value.label && !labelOnTheTopOrOnTheLeft) {
          label.appendChild(labelSpan);
        }

        labelWrapper.appendChild(label);
        inputGroup.appendChild(labelWrapper);
        wrappers.push(labelWrapper);
      });

      this.wrappers = wrappers;
      container.appendChild(inputGroup);
      this.container = container;
      this.errorContainer = container;
      this.createDescription(this.container);

      if (!this.component.hideScore) {
        this.addScoreElement(this.container);
      }

      if (!this.viewOnly) {
        this.setScoreValues();
      }
    }
  }, {
    key: "createDescription",
    value: function createDescription(container) {
      if (!this.component.description) {
        return;
      }

      if (!this.descriptionElement) {
        this.description = this.ce('div', {
          style: 'order: 0; margin-bottom: 15px',
          class: 'help-block description'
        });
        this.description.innerHTML = this.t(this.component.description);
        container.appendChild(this.description);
        this.descriptionElement = container.querySelector('.description');
      }
    }
  }, {
    key: "addScoreElement",
    value: function addScoreElement(container) {
      var _this1 = this;

      container.appendChild(this.ce('div', {
        class: "score-select form-group formio-component formio-component-select"
      }, this.ce('label', {
        style: 'width: 100%'
      }, [this.ce('span').textContent = 'Оценка: ', this.ce('select', {
        class: 'form-control',
        onChange: function onChange() {
          _this1.setScoreValues(true);

          _this1.triggerChange();
        }
      })])));
      this.selectElement = container.querySelector('select');
    }
  }, {
    key: "getValue",
    value: function getValue() {
      if (this.viewOnly) {
        return typeof this.dataValue === 'string' ? {
          radioValue: this.dataValue,
          selectValue: ''
        } : this.dataValue;
      }

      var radioValue = '';

      _lodash.default.each(this.inputs, function (input) {
        if (input.checked) {
          radioValue = input.value;

          if (radioValue === 'true') {
            radioValue = true;
          } else if (radioValue === 'false') {
            radioValue = false;
          } else if (!isNaN(parseInt(radioValue, 10)) && isFinite(radioValue)) {
            radioValue = parseInt(radioValue, 10);
          }
        }
      });

      return {
        radioValue: String(radioValue),
        selectValue: this.selectElement ? this.selectElement.value : ''
      };
    }
  }, {
    key: "transformExpertiseRadioValue",
    value: function transformExpertiseRadioValue(value) {
      // раньше: значение компоненты было string, в селекте автоматически выставлялась первая опция
      // сейчас: если с бэка пришло значение string, то конвертируем его в
      // объект вида { radioValue: string, selectValue: string };
      var transformedValue = value;

      if (typeof transformedValue === 'string') {
        transformedValue = {
          radioValue: value,
          selectValue: ''
        };
      }

      if (transformedValue === null || transformedValue === undefined) {
        transformedValue = this.emptyValue;
      }

      return transformedValue;
    }
  }, {
    key: "updateValue",
    value: function updateValue(flags, value) {
      var _this7 = this;

      if (this.dataValue) {
        var isRadioValueChanged = !_lodash.default.isEqual(this.dataValue.radioValue, this.getValue().radioValue);

        if (isRadioValueChanged && this.selectElement) {
          this.selectElement.value = '';
        }
      }

      var changed = _get(_getPrototypeOf(Radio.prototype), "updateValue", this).call(this, flags, value);

      if (changed) {
        //add/remove selected option class
        var _value = this.dataValue.radioValue;
        var optionSelectedClass = 'radio-selected';

        _lodash.default.each(this.wrappers, function (wrapper, index) {
          var input = _this7.inputs[index];

          if (input.value.toString() === _value.toString()) {
            //add class to container when selected
            _this7.addClass(wrapper, optionSelectedClass);
          } else {
            _this7.removeClass(wrapper, optionSelectedClass);
          }
        });
      }

      if (!this.viewOnly && !this.component.hideScore && !this.isEmpty(this.dataValue) && !flags.noUpdateEvent && this.selectElement) {
        this.clearOptions();
        this.setScoreOptions();
      } else if (!this.viewOnly) {
        this.setScoreValues();
      }

      return changed;
    }
  }, {
    key: "clearOptions",
    value: function clearOptions() {
      this.selectElement.innerHTML = '';
    }
  }, {
    key: "setScoreOptions",
    value: function setScoreOptions(isAfterSetValues) {
      var _this8 = this;

      var radioValue = this.transformExpertiseRadioValue(this.dataValue).radioValue;

      if (radioValue && this.selectElement) {
        this.selectElement.appendChild(this.ce('option', {
          value: '',
          disabled: true,
          hidden: true,
          selected: true
        }));

        if (this.valueScoreListMap && this.valueScoreListMap[radioValue]) {
          this.valueScoreListMap[radioValue].forEach(function (score) {
            _this8.appendOptionToSelect(score);
          });
        } else {
          var score = this.valueScoreMap[radioValue] || 0;
          this.appendOptionToSelect(score);
        }

        this.setSelectValue(this.dataValue.selectValue || '');
      }

      if (!isAfterSetValues) {
        this.setScoreValues();
      }
    }
  }, {
    key: "appendOptionToSelect",
    value: function appendOptionToSelect(score) {
      if (this.selectElement) {
        this.selectElement.appendChild(this.ce('option', {
          value: score
        }, this.ce('span', null).textContent = String(score)));
      }
    }
  }, {
    key: "getView",
    value: function getView(value) {
      var transformedValue = this.transformExpertiseRadioValue(value);
      var radioValue = transformedValue.radioValue,
          selectValue = transformedValue.selectValue;

      if (!radioValue) {
        return '';
      }

      if (!_lodash.default.isString(radioValue)) {
        return _lodash.default.toString(radioValue || '');
      }

      var option = _lodash.default.find(this.component.values, function (v) {
        return v.value === radioValue;
      });

      if (this.descriptionElement) {
        this.createDescription(this.element);
      }

      if (!this.component.hideScore && !this.selectElement) {
        this.addScoreElement(this.element);
        this.selectElement.disabled = true;
        this.selectElement.parentElement.style.marginTop = '10px';
        var score;

        if (radioValue && selectValue) {
          score = this.data["score-".concat(this.component.key)] || 0;
          this.valueScoreMap[radioValue] = score;
        } else {
          score = '';
          this.valueScoreMap[radioValue] = 0;
        }

        this.appendOptionToSelect(String(score));
      }

      if (!this.component.hideScore && this.viewOnly) {
        var _score;

        if (radioValue && selectValue) {
          _score = Number(selectValue) || 0;
          this.valueScoreMap[radioValue] = _score;
          this.setScoreToData(_score);
        } else {
          _score = '';
        }

        this.clearOptions();
        var scoreConvertedToString = String(_score);
        this.appendOptionToSelect(scoreConvertedToString);
        this.setSelectValue(scoreConvertedToString);
      }

      return _lodash.default.get(option, 'label');
    }
  }, {
    key: "setValueAt",
    value: function setValueAt(index, value) {
      var radioValue = value;

      if (_typeof(value) === 'object' && value !== null) {
        radioValue = value.radioValue || '';
      }

      _get(_getPrototypeOf(Radio.prototype), "setValueAt", this).call(this, index, radioValue);
    }
  }, {
    key: "setSelectValue",
    value: function setSelectValue(value) {
      if (this.selectElement) {
        var options = this.selectElement.querySelectorAll('option');

        _lodash.default.each(options, function (option) {
          if (option.value === value) {
            option.setAttribute('selected', 'selected');
          } else {
            option.removeAttribute('selected');
          }
        });
      }
    }
  }, {
    key: "setValue",
    value: function setValue(value, flags) {
      var transformedValue = value;

      if (typeof value === 'string') {
        transformedValue = {
          radioValue: value,
          selectValue: this.selectElement ? this.selectElement.value : ''
        };
      }

      flags = this.getFlags.apply(this, arguments);

      if (!this.hasInput) {
        return false;
      }

      if (this.component.multiple && !Array.isArray(transformedValue)) {
        transformedValue = transformedValue ? [transformedValue] : [];
      }

      this.buildRows(transformedValue);
      var isArray = Array.isArray(transformedValue);

      for (var i in this.inputs) {
        if (this.inputs.hasOwnProperty(i)) {
          this.setValueAt(i, isArray ? transformedValue[i] : transformedValue, flags);
        }
      }

      return this.updateValue(flags, transformedValue);
    }
  }, {
    key: "setScoreToData",
    value: function setScoreToData(score) {
      this.data["score-".concat(this.component.key)] = score;
    }
  }, {
    key: "defaultSchema",
    get: function get() {
      return Radio.schema();
    }
  }, {
    key: "emptyValue",
    get: function get() {
      return {
        radioValue: '',
        selectValue: ''
      };
    }
  }], [{
    key: "schema",
    value: function schema() {
      for (var _len = arguments.length, extend = new Array(_len), _key = 0; _key < _len; _key++) {
        extend[_key] = arguments[_key];
      }

      return _Radio.default.schema.apply(_Radio.default, [{
        type: 'expertiseRadio',
        label: 'Radio',
        key: 'expertiseRadio'
      }].concat(extend));
    }
  }, {
    key: "editForm",
    value: function editForm() {
      for (var _len2 = arguments.length, extend = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        extend[_key2] = arguments[_key2];
      }

      return _BaseExpertiseForm.default.apply(void 0, [[{
        key: 'display',
        components: RadioEditDisplay
      }, {
        label: 'Expertise',
        key: 'expertise',
        weight: 15,
        components: [{
          type: 'number',
          input: true,
          weight: 10,
          key: 'weight',
          label: 'Вес',
          validate: {
            required: true
          }
        }]
      }]].concat(extend));
    }
  }, {
    key: "builderInfo",
    get: function get() {
      return {
        title: 'Radio',
        icon: 'fa fa-dot-circle-o',
        group: 'expertise',
        weight: 30,
        schema: Radio.schema()
      };
    }
  }]);

  return Radio;
}((0, _ExpertiseComponent2.default)(_Radio.default)); // Копипаст с formiojs/components/radio/editForm/Radio.edit.display заисключение добавления весов в поле "Values"


exports.default = Radio;
var RadioEditDisplay = [{
  type: 'select',
  input: true,
  label: 'Options Label Position',
  key: 'optionsLabelPosition',
  tooltip: 'Position for the label for options for this field.',
  dataSrc: 'values',
  weight: 32,
  defaultValue: 'right',
  data: {
    values: [{
      label: 'Top',
      value: 'top'
    }, {
      label: 'Left',
      value: 'left'
    }, {
      label: 'Right',
      value: 'right'
    }, {
      label: 'Bottom',
      value: 'bottom'
    }]
  }
}, {
  type: 'datagrid',
  input: true,
  label: 'Values',
  key: 'values',
  tooltip: 'The radio button values that can be picked for this field. Values are text submitted with the form data. Labels are text that appears next to the radio buttons on the form.',
  weight: 33,
  reorder: true,
  defaultValue: [{
    label: '',
    value: '',
    score: 0
  }],
  components: [{
    label: 'Label',
    key: 'label',
    input: true,
    type: 'textfield',
    validate: {
      required: 'true'
    }
  }, {
    label: 'Value',
    key: 'value',
    input: true,
    type: 'textfield',
    allowCalculateOverride: true,
    calculateValue: {
      _camelCase: [{
        var: 'row.label'
      }]
    },
    validate: {
      required: 'true'
    }
  }, {
    label: 'Баллы',
    key: 'score',
    input: true,
    type: 'textfield',
    validate: {
      pattern: '([0-9;]*)'
    },
    tooltip: 'Для внесения нескольких баллов, используйте разделитель ";"'
  }]
}, {
  type: 'checkbox',
  input: true,
  key: 'inline',
  label: 'Inline Layout',
  tooltip: 'Displays the checkboxes/radios horizontally.',
  weight: 650
}, {
  weight: 1301,
  type: 'checkbox',
  label: 'Hide score',
  tooltip: 'Скрывает баллы при выборе варианта',
  key: 'hideScore',
  input: true
}];
exports.RadioEditDisplay = RadioEditDisplay;